import { Button, Color, Panel, PanelProps, Spacing, Text } from 'zens-storybook'
import React, { PropsWithChildren, ReactElement } from 'react'
import { StyleSheet, View } from 'react-native'

import { Href, Link } from 'zens-router'

import AuthLanguage from './language'

const styles = StyleSheet.create({
  container: {
    flex: 1,
    minHeight: 442,
    backgroundColor: Color.simplyWhite,
    padding: Spacing.XL,
  },
  background: {
    backgroundColor: 'transparent' as const,
  },
  top: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: Spacing.M,
    minHeight: 40,
  },
  title: {
    flex: 1,
    textAlign: 'center',
  },
  titleBack: {
    marginRight: 40,
  },
  content: {
    paddingHorizontal: Spacing.XL,
    flex: 1,
  },
  bottom: {
    marginTop: Spacing.XL,
    alignItems: 'flex-end',
    paddingHorizontal: Spacing.XL,
  },
  footer: {
    flexDirection: 'row',
    paddingVertical: Spacing.S,
    alignItems: 'center',
  },
  terms: {
    flex: 1,
    marginHorizontal: Spacing.XS,
  },
  // termsText: {
  //   color: Color.graphiteGrey,
  // },
})

interface Props extends PanelProps {
  title?: string
  bottom?: ReactElement
  backHref?: Href
}
const AuthPanel = (props: PropsWithChildren<Props>) => {
  const { title, bottom, backHref, children, ...otherProps } = props

  const Footer = (
    <View style={styles.footer}>
      <View style={styles.terms} />
      {/* <Hyperlink
        title={t('Privacy and terms')}
        href="/terms"
        style={styles.terms}
        textStyle={styles.termsText}
        testID="AuthPanel.Terms"
      /> */}
      <AuthLanguage />
    </View>
  )

  return (
    <Panel footer={Footer} backgroundStyle={styles.background} {...otherProps}>
      <View style={styles.container}>
        <View style={styles.top}>
          {!!backHref && (
            <Link href={backHref} asChild>
              <Button left="left" testID="AuthPanel.Back" round light />
            </Link>
          )}
          <Text level={2} style={[styles.title, !!backHref && styles.titleBack]}>
            {title}
          </Text>
        </View>
        <View style={styles.content}>{children}</View>
        <View style={styles.bottom}>{bottom}</View>
      </View>
    </Panel>
  )
}

export default AuthPanel
